import io from 'socket.io-client'
import _ from 'underscore';
import Vue from 'vue'
import router from '../route'
import { getSocketPayload } from '../utils';

const LOADER_TIMEOUT_IN_MS = 60 * 1000; // 60 seconds

const state = () => ({
    rooms: [],
    currentRoom: null,
    currentParticipant: null,
    mainRoom: null,
    name: '',
    isBreakoutRoomsHidden: isMobileOrTouchDevice(),
    isBreakoutRoomsPinned: false,
    showFacilitatorControls: !isMobileOrTouchDevice(),
    loading: true,
    loadingTimeout: null,
    socket: io(`${process.env.VUE_APP_SERVER_URL}vf`),
    socketRooms: [],
    conferenceId: null,
    mainRoomTimeOut: false,
    isVideoMuted: false,
    isAudioMuted: false,
    showControls: true,
    showBreakouts: true,
    raisedHandsList: [],
    isSwitching: false,
    enableIframeIndex: false,
    isMuteBarVisible: false
})

const isMobileOrTouchDevice = () => {
    if((window.innerWidth < 768) || ("ontouchstart" in document.documentElement)) {
        // If it is touch or mobile device returns true
        return true;
    } else {
        // returns false
        return false;
    }
}

const getters = {
    getRoom: (state, _id) => {
        return state.rooms.find(room => room._id === _id);
    },

    getRoomByGetter: (state)=>(_id)=>{
        return getters.getRoom(state,_id);
    },

    getSocket: (state) => {
        return state.socket;
    },

    getNeedHelp: (state) => (id) => {
        const room = state.rooms.find(room => room.roomId === id);
        return room ? room.needHelp : false
    },

    hasSharedLinks: (state) => (id) => {
        const room = state.rooms.find(room => {
            return room._id === id|| room.roomId === id
        });
        return room && room.sharedLinks && room.sharedLinks.length > 0
    },

    getSharedLinks: (state) => (id) => {
        const room = state.rooms.find(room => {
            return room._id === id || room.roomId === id
        });
        return room &&  room.sharedLinks
    },

    sortRooms: () => (rooms) => {
        return _.sortBy(rooms, (room) => {
            return room.rank ? room.rank : 0;
        });
    },

    filterRooms: () => (rooms, keyword, isParticipantNamesAccessible) => {
        const find = (text, key) => {
            return text.toLowerCase().includes(key.toLowerCase());
        }
        let filteredRooms = [];
        rooms.forEach(room => {
            if (!keyword) {
                room.foundBy = null;
                filteredRooms.push(room);
            } else {
                const keywordInParticipant = isParticipantNamesAccessible && room.participants.some(p => find(p.displayName, keyword));
                const keywordInName = find(room.name, keyword);
                const keywordInTopic = find(room.topic, keyword);
                if (keywordInParticipant || keywordInName || keywordInTopic) {
                    if (keywordInParticipant) {
                        room.foundBy = "participant";
                    } else if (keywordInName) {
                        room.foundBy = "name";
                    } else {
                        room.foundBy = "topic";
                    }
                    filteredRooms.push(JSON.parse(JSON.stringify(room)));
                }
            }
        });
        return filteredRooms;
    },

    joinRoom: (state) => (roomToJoin) => {
        router.replace({
            name: "Join",
            params: {
                room: roomToJoin,
                roomName: state.mainRoom.name,
                mainRoom: state.mainRoom,
                name: state.name
            },
            query: { id: roomToJoin.urlID }
        });
    },

    isAudioMuted: (state) => {
        return state.isAudioMuted
    },

    isVideoMuted: (state) => {
        return state.isVideoMuted
    },

    getRaiseHandsList: (state) => {
        return state.raisedHandsList;
    },
    isSwitchingRoom: (state) => state.isSwitching,
    isMuteBarVisible: (state) => {
        return state.isMuteBarVisible;
    }
}


const mutations = {

    setRooms(state, rooms) {
        state.rooms = rooms;
        state.currentRoom = getters.getRoom(state, state.currentRoom._id)
        state.mainRoom = getters.getRoom(state, state.mainRoom._id)
    },

    setParticipants(state, participants) {
        state.currentRoom.participants = participants;
        const index = state.rooms.findIndex(r => r._id === state.currentRoom._id);
        if (index >= 0) {
            state.rooms[index].participants = state.currentRoom.participants;
        }
    },

    setParticipantsOfRoom(state, room) {
        const index = state.rooms.findIndex(r => r._id == room.roomId);
        if (index >= 0){
            state.rooms[index].participants = room.participants;
        }
    },

    setCurrentParticipant(state, user) {
        state.currentParticipant = user;
    },

    changeRoom(state) {
        state.socket.emit("ROOM_CHANGE", getSocketPayload(state.currentParticipant));
    },

    addRoom(state, room) {
        state.rooms.push(room);
    },

    removeRoom(state, room) {
        const index = state.rooms.findIndex(r => r._id === room._id)
        state.rooms.splice(index, 1)

    },

    updateRoom(state, room) {
        const index = state.rooms.findIndex(r => r._id === room._id)
        if (index === -1) {
            state.rooms.push(room);
        } else {
            Vue.set(state.rooms, index, room)
        }
        if (room._id === state.currentRoom._id) {
            state.currentRoom = room
        }
        if (state.currentRoom._id === state.mainRoom._id) {
            const uri = state.currentRoom.name.toLowerCase() === state.currentRoom.urlID.toLowerCase() ? '/join/' + state.currentRoom.name : '/join/' + state.currentRoom.name + '?id=' + state.currentRoom.urlID
            window.history.replaceState({}, 'vf', uri);
        }
    },

    // ! socket Rooms are not being used anymore
    setSocketRooms(state, rooms) {
        state.socketRooms = rooms
    },


    setMainRoom(state, room) {
        state.mainRoom = room;
    },

    setCurrentRoom(state, room) {
        if (state.currentRoom && room && state.currentRoom._id != room.id) {
            state.raisedHandsList = [];
        }
        state.currentRoom = room
    },

    setName(state, name) {
        state.name = name
    },

    setHelpNeedRooms(state, rooms) {
        state.helpNeedRooms = rooms
    },

    setWhiteBoardRooms(state, rooms) {
        state.whiteBoardRooms = rooms
    },

    resetRooms(state) {
        state.rooms = [state.mainRoom];
    },

    setLastN(state, rooms) {
        state.roomsLastN = rooms;
    },

    setBreakoutRoomsHidden(state) {
        state.isBreakoutRoomsHidden = !state.isBreakoutRoomsHidden;
    },

    hideBreakoutRooms(state) {
        state.isBreakoutRoomsHidden = true;
    },

    showBreakoutRooms(state) {
        state.isBreakoutRoomsHidden = false;
    },

    toggleRoomsPin(state) {
        state.isBreakoutRoomsPinned = !state.isBreakoutRoomsPinned
    },

    toggleFacilitatorControls(state) {
        state.showFacilitatorControls = !state.showFacilitatorControls
    },

    hideFacilitatorControls(state) {
        state.showFacilitatorControls = false
    },

    setLoading(state, status) {
        state.loading = status
        if(status){
            clearTimeout(state.loadingTimeout);
            state.loadingTimeout = setTimeout(()=>{
                window.location.reload();
            },LOADER_TIMEOUT_IN_MS)
        }else{
            clearTimeout(state.loadingTimeout);
            state.loadingTimeout = null;
        }
    },

    timeOut(state, status) {
        if (state.currentRoom._id !== state.mainRoom._id) {
            state.mainRoomTimeOut = status
        }
    },

    setConferenceId(state, conferenceId) {
        state.conferenceId = conferenceId
    },

    setAudioState(state, isAudioMuted) {
        state.isAudioMuted = isAudioMuted;
    },

    setVideoState(state, isVideoMuted) {
        state.isVideoMuted = isVideoMuted
    },
    addSharedLink(state, { roomId, link }) {
        if (!link) return;
        const room = state.rooms.find(room => room.roomId === roomId);
        if (!room) return
        room.sharedLinks.push(link)
    },

    deleteSharedLink(state, { roomId, index }) {
        const room = state.rooms.find(room => room.roomId === roomId);
        if (!room) return
        room.sharedLinks.splice(index, 1)
    },

    updateSharedLinks(state, { roomId, sharedLinks }) {
        const room = state.rooms.find(room => room.roomId === roomId);
        if (!room) return
        room.sharedLinks = sharedLinks
    },

    hideControlWindows(state) {
        state.showBreakouts = false
        state.showControls = false
    },

    showControlWindows(state) {
        state.showBreakouts = true
        state.showControls = true
    },

    raiseHand(state, event) {
        const { id: participantId, handRaised } = event;
        // maintain only existing participants
        state.raisedHandsList = state.raisedHandsList.filter(participant => {
            return state.currentRoom.participants.find(cp => cp.participantId === participant.id);
        })
        if(!handRaised){
            state.raisedHandsList = state.raisedHandsList.filter(p => p.id != participantId);
        }else{
            const participantData = state.currentRoom.participants.find(p => p.participantId === participantId);
            if (!participantData) return;
            const existingIndex= state.raisedHandsList.findIndex((p)=>p.id==participantData.participantId);

            if(existingIndex>=0 && existingIndex==(state.raisedHandsList.length-1)) return;

            if(existingIndex>=0){
                state.raisedHandsList.splice(existingIndex,1)
            }

            const data = {
                id: participantData.participantId,
                name: participantData.displayName,
                formattedName: state.currentParticipant.id === participantData.participantId ? state.currentParticipant.formattedDisplayName : participantData.displayName,
                timestamp: new Date().toISOString()
            }
            state.raisedHandsList.push(data);
        }
    },

    removeRaiseHand(state, participantId) {
        state.raisedHandsList = state.raisedHandsList.filter(participant => participant.id !== participantId)
    },
    setIsSwitchingRoom(state, switching) {
        state.isSwitching = switching;
    },
    setIframeIndex(state, enable) {
        state.enableIframeIndex = enable;
    },
    setMuteBarVisibleStatus(state, visible) {
        state.isMuteBarVisible = visible;
    },

}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}
